/*
 * @Author: your name
 * @Date: 2020-12-15 17:13:02
 * @LastEditTime: 2021-01-05 14:17:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Renderer.js
 */
/**
 * @Description 渲染器类，仅初始化渲染器，实际渲染调用在CameraController中
 * @Author iCEA
 * @Date 2020-10-29
 * @Version 1.0
 */

import * as THREE from 'three'

class Renderer {
  /**
   * 渲染器构造函数
   * @param {Element} dom canvas父级的dom元素
   */
  constructor (dom) {
    /**
     * @type {THREE.Renderer} WEBGL渲染器
     */
    this.renderer = null
    /**
     * @type {boolean} 是否激活了当前的canvas，若为false，屏蔽键鼠输入
     */
    this.active = false

    this.initRender(dom)
  }

  /**
   * 初始化渲染器，添加dom元素
   * @param {Element} dom canvas的父级dom元素
   */
  initRender (dom) {
    this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true }) // 抗锯齿
    this.renderer.setSize(dom.clientWidth, dom.clientHeight)
    this.renderer.setClearColor(0x222222)

    this.renderer.gammaOutput = true
    this.renderer.setPixelRatio(window.devicePixelRatio)
    // this.renderer.gammaFactor = 2.0

    dom.appendChild(this.renderer.domElement)
    this.renderer.domElement.style.opacity = '1'
  }
}

export {
  Renderer
}
